module.exports = __webpack_public_path__ + "img/32_23.2f218cd6.png";